import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, delay, firstValueFrom, of } from 'rxjs';
import { PERMISSION_AUDIT_READ, PERMISSION_ROLE_MANAGE } from './permissions.constants';

/**
 * The permissions the signed-in user holds, as the authorization service grants them.
 *
 * There is no endpoint yet, so `fetchPermissions` is the whole seam: it grants every known
 * permission today, and the backend ticket replaces its body and nothing else.
 */
@Injectable({
  providedIn: 'root'
})
export class PermissionsService {
  private readonly _permissions = new BehaviorSubject<string[]>([]);

  public readonly permissions$: Observable<string[]> = this._permissions.asObservable();

  private _loading?: Promise<void>;

  ensurePermissionsLoaded(): Promise<void> {
    this._loading ??= firstValueFrom(this.fetchPermissions()).then(permissions => this._permissions.next(permissions));
    return this._loading;
  }

  hasPermission(permission: string): boolean {
    return this._permissions.value.includes(permission);
  }

  // Must stay asynchronous: a synchronous answer would change the rail inside the change-detection
  // pass that rendered it (NG0100), which an HTTP call never does.
  private fetchPermissions(): Observable<string[]> {
    return of([PERMISSION_ROLE_MANAGE, PERMISSION_AUDIT_READ]).pipe(delay(0));
  }
}
